var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0a10 10 0 1 0 10 10A10.01 10.01 0 0 0 10 0m0 17.5a7.5 7.5 0 1 1 7.5-7.5 7.51 7.51 0 0 1-7.5 7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.75 9.213-2 1.25a1.252 1.252 0 0 0 .384 2.278 1.25 1.25 0 0 0 .944-.16l2.39-1.5a1.67 1.67 0 0 0 .782-1.416V6.477a1.25 1.25 0 0 0-2.5 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgClock);
export default Memo;